import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-auth',
    template: '<router-outlet><app-spinner></app-spinner></router-outlet>',
    standalone: false
})
export class AuthComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
